import { CommonLaboratoryDatasource } from '@/shared/resources/datasources/common/common-laboratory-datasource'
import { BillableDeliveryNoteResponse } from '@/api/services/billing/common-delivery-note/billing-common-delivery-note.dto'
import { billingCommonDeliveryNoteService } from '@/api/services/billing/common-delivery-note/billing-common-delivery-note.service'
import { CommonFilterModel, CommonParams, ExportCommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { store } from '@/store/store'
import { GridUtils } from '@/shared/util/grid-utils'
import { ReportGridRequest } from '@/api/services/common.dto'
import { AxiosResponse } from 'axios'

export class BillingModalInvoicesCrudGridDatasource extends CommonLaboratoryDatasource<BillableDeliveryNoteResponse> {
    private readonly _invoiceId: number | undefined

    constructor(invoiceId?: number) {
        super(store.getters.labId)
        this._invoiceId = invoiceId
    }

    protected fetchData(filterModel: CommonFilterModel, params: CommonParams): Promise<IResponseAgGrid<BillableDeliveryNoteResponse>> {
        const _filterModel: CommonFilterModel = { ...filterModel }
        if (this._invoiceId) {
            _filterModel['invoice.id'] = GridUtils.getNumberFilterModel('equals', this._invoiceId)
        }
        return billingCommonDeliveryNoteService.paginator(_filterModel, params, this.laboratoryId)
    }

    public exporter(request: ReportGridRequest, params: ExportCommonParams): Promise<AxiosResponse<Blob>> {
        const filterModel: CommonFilterModel = { ...request.filterModel }
        if (this._invoiceId) {
            filterModel['invoice.id'] = GridUtils.getNumberFilterModel('equals', this._invoiceId)
        }
        const _request: ReportGridRequest = { ...request, filterModel }
        return billingCommonDeliveryNoteService.export(this.laboratoryId, _request, params)
    }
}
